
import { OptionsClass } from "@/domain/entities/MainApp";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<any>({
    required: true
  });
  placeholder = prop<string>({
    default: "",
    type: String
  });
  value = prop<string>({
    default: "",
    type: String
  });
  isDisabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  disableBackground = prop<boolean>({
    default: false,
    type: Boolean
  });
  isExpand = prop<string | boolean>({
    default: "",
    type: Boolean || String
  });
  options = prop<Array<any>>({
    default: [],
    type: Array
  });
  isCustomWidth = prop<boolean>({
    default: false,
    type: Boolean
  });
  selectedItem = prop<any>({
    default: { name: "", value: "" } || ""
  });
  customValueStyle = prop<string>({
    default: "",
    type: String
  });
  customChevronStyle = prop<string>({
    default: "",
    type: String
  });
  customOptionStyle = prop<string>({
    default: "",
    type: String
  });
  isCustomMaxHeight = prop<boolean>({
    default: false,
    type: Boolean
  });
  isCheck = prop<boolean>({
    default: false,
    type: Boolean
  });
  counter = prop<number>({
    default: 0,
    type: Number
  });
  error = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorCaption = prop<string>({
    default: "",
    type: String
  });
  expandUpwards = prop<boolean>({
    default: false
  });
  customClassExpand = prop<string>({
    default: "absolute flex",
    type: String
  });
  customClassHeight = prop<string>({
    default: "h-10",
    type: String
  });
  preventUnselect = prop<boolean>({
    default: false,
    type: Boolean
  })
  isCustomChevronDisable = prop<boolean>({
    default: false,
    type: Boolean
  });
  isFocusable = prop<boolean>({
    default: false
  });
  customChips = prop<string>({
    default: "",
    type: String
  });
  customBorderColor = prop<string>({
    default: "border-gray-lp-400",
    type: String
  });
  customClassField = prop<string>({
    default: "",
    type: String
  });
  customStyleField = prop<string>({
    default: "",
    type: String
  })
  customBorderRadius = prop<string>({
    default: "", // e.g -sm/-md/-lg... to provide for different sides better
    type: String
  })
}

@Options({
  emits: [
    "update:isExpand",
    "update:modelValue",
    "update:selectedItem",
    "select",
    "close"
  ]
})
export default class CustomSelect extends Vue.with(Props) {
  openSelect = false;
  selectedIndex = -1;
  expandSelect() {
    if (!this.isDisabled) {
      this.openSelect = true;
      this.$emit("update:isExpand", true);
      if (this.selectedItem) {
        this.selectedIndex = this.options.findIndex((option: any) => option.value === this.selectedItem.value);
      }
    }
  }
  closeSelect() {
    if (!this.isDisabled) {
      this.$emit("close", this.openSelect);
      this.openSelect = false;
      this.$emit("update:isExpand", false);
      this.selectedIndex = -1;
    }
  }

  get placeholderStyle() {
    if (this.isDisabled) {
      return "text-gray-lp-600";
    }
    if (this.value || this.selectedItem?.value || this.defaultValue) {
      return "text-black-lp-300";
    }
    return "text-gray-lp-600";
  }

  get defaultValue() {
    if (typeof this.selectedItem === "string") {
      return this.options.find(
        item =>
          item.name === this.selectedItem || item.value === this.selectedItem
      )?.name;
    }
    return "";
  }

  isActive(option: any) {
    return this.selectedItem.value === option.value;
  }

  onChoose(option: any) {
    if (option?.disabled) return;

    if (this.isActive(option) && !this.preventUnselect) {
      this.$emit("update:modelValue", { name: "", value: "" });
      this.$emit("update:selectedItem", { name: "", value: "" });
      this.$emit("select", new OptionsClass());
    } else {
      this.$emit("update:modelValue", option);
      this.$emit("update:selectedItem", option);
      this.$emit("select", option);
    }
  }

  onSelect(option: any) {
    this.onChoose(option);
    this.closeSelect();
  }

  onFocus() {
    if (!this.isFocusable) return;
    if (this.openSelect){
      this.closeSelect()
    } else  this.expandSelect()

  }

  onBlur() {
    if (!this.isFocusable) return;
    this.closeSelect()
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === " ") {
      event.preventDefault();
      if (this.selectedIndex > -1) {
        const option = this.options[this.selectedIndex];
        this.$emit("update:modelValue", option);
        this.$emit("update:selectedItem", option);
        this.$emit("select", option);
        this.closeSelect();
      }
    }
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();

      if (event.key === "ArrowDown") {
        this.selectedIndex += 1;
      }
      if (event.key === "ArrowUp") {
        this.selectedIndex -= 1;
      }

      if (this.selectedIndex === this.options?.length) {
        this.selectedIndex = 0;
      }
      if (this.selectedIndex < 0) {
        this.selectedIndex = this.options?.length - 1;
      }
      if (!this.options[this.selectedIndex]) {
        return;
      }
      this.onChoose(this.options[this.selectedIndex]);
    }
  }
}
